<div class="cart-component-page section-padding" id="cart">
  <div class="cart-page-width">
    <app-checkout-header name="cart" [total]="calculateTotal()"></app-checkout-header>

    <h4 class="page-title">Review your cart</h4>

    <section class="card-section">
      <div class="card-header">
        <h5 class="header">Cart Items</h5>
        <div class="empty-cart" (click)="deleteCart($event, true)">
          <img src="assets/icon/delete-cart-icon.svg" class="delete-icon" alt="Delete Icon">
          <p class="text">Empty Cart</p>
        </div>
      </div>
      <div class="card-content">
        <input type="checkbox" class="hidden-checkbox" id="items" [(ngModel)]="items" />
        <label class="sub-header" for="items">
          <p>Items</p>
          <img src="assets/icon/tab-arrow.svg" class="tab-arrow" alt="Tab Arrow" height="32" width="32" loading="lazy">
        </label>
        <div class="content">
          <input type="checkbox" class="hidden-checkbox" id="lines" [(ngModel)]="lines" />
          <label class="content-line" for="lines">
            <p class="smaller">Line{{userCart?.cartType === CART_TYPES.NEW_PLAN ? " #1" : ": " + mappedPurchasedMdn}}
            </p>
            <img src="assets/icon/circle-tab-arrow.svg" class="tab-arrow" alt="Tab Arrow" height="20" width="20"
              loading="lazy">
          </label>
          <div class="sub-content content-padding">
            <div class="item-details" *ngIf="userCart?.cartType !== CART_TYPES.PLAN_ITEMS">
              <div class="details-flex">
                <div class="image-side">
                  <img src="assets/icon/plan_thumbnail.svg" class="item-icon" alt="Plan Icon">
                </div>
                <div class="details">
                  <p class="info smaller" *ngIf="userCart?.basePlan?.details?.data === 0">
                    <b>{{userCart?.basePlan?.subtitle}}</b>
                  </p>
                  <p class="info smaller" *ngIf="userCart?.basePlan?.details?.data > 0">
                    <b>{{userCart?.basePlan?.details?.data > 9999 ? 'Unlimited' :
                      (userCart?.basePlan?.details?.data >= 1024 ?
                      ((userCart?.basePlan?.details?.data/1024) + 'GB') :
                      ((userCart?.basePlan?.details?.data) + 'MB'))}} 5G
                    </b>
                  </p>
                  <p class="info smaller" *ngIf="!userCart?.basePlan?.isSpecialPromotion">
                    {{userCart?.basePlan?.title}}
                  </p>
                  <p class="info smaller last" *ngIf="userCart?.cartType === CART_TYPES.NEW_PLAN">
                    <b>(New Plan)</b>
                  </p>
                  <p class="info smaller last" *ngIf="userCart?.cartType === CART_TYPES.CHANGE_PLAN">
                    <b>(Change Plan)</b>
                  </p>
                  <p class="info smaller last" *ngIf="userCart?.cartType === CART_TYPES.TOPUP_PLAN">
                    <b>(Refill)</b>
                  </p>
                  <div class="auto-renew-part">
                    <input type="checkbox" class="autorenew-checkbox" [(ngModel)]="autoRenew"
                      (change)="updateAutoRenew()">
                    <p class="smaller">
                      Auto Renew
                      <span class="tooltip">
                        <img src="assets/icon/circle-info-icon.svg" class="info smaller-icon" alt="info smaller Icon"
                          height="16" width="16" loading="lazy">
                        <span class="tooltipInfo">
                          <p class="smallest">
                            A payment card is required to be saved in Auto Renew
                          </p>
                        </span>
                      </span>
                    </p>
                  </div>
                  <p class="info smaller quantity">Quantity: {{userCart?.quantity}}</p>
                  <div class="item-actions">
                    <button class="button tertiary action" *ngIf="userCart?.cartType !== CART_TYPES.TOPUP_PLAN"
                      (click)="goToPlans()">Change</button>
                    <button class="button tertiary action" *ngIf="userCart?.cartType !== CART_TYPES.TOPUP_PLAN"
                      (click)="deleteCart('plan')">Delete</button>
                    <button class="button tertiary action" *ngIf="userCart?.cartType === CART_TYPES.TOPUP_PLAN"
                      (click)="deleteCart('plan')">Remove</button>
                  </div>
                </div>
              </div>
              <p class="info smaller price" *ngIf="userCart?.cartType !== CART_TYPES.TOPUP_PLAN && !!isApplicablePromo">
                <b>
                  ${{(userCart?.basePlan?.subscriptionCycles ? userCart?.basePlan?.promoMoPrice :
                  userCart?.basePlan?.price) | number : '1.0-2'}}/mo
                </b>
              </p>
              <p class="info smaller price" *ngIf="userCart?.cartType === CART_TYPES.TOPUP_PLAN || !isApplicablePromo">
                <b>
                  ${{userCart?.basePlan?.price | number : '1.0-2'}}/mo
                </b>
              </p>
            </div>
            <ng-container *ngIf="userCart?.cartType === CART_TYPES.NEW_PLAN && !userCart?.activationCode">
              <hr class="border sim">
              <div class="item-details sim">
                <div class="details-flex">
                  <div class="image-side">
                    <img [src]="!userCart?.eSIM ? 'assets/icon/sim-icon.svg' : 'assets/img/esim.svg'" class="sim-icon"
                      [class.esim-icon]="userCart?.eSIM" alt="SIM Icon" height="61" width="37" loading="lazy">
                  </div>
                  <div class="details">
                    <p class="info smaller">
                      <b>{{!!userCart?.eSIM ? 'e': ''}}SIM Card</b>
                    </p>
                    <p class="info smaller last"><b>(New)</b></p>
                    <p class="info smaller quantity">Quantity: 1</p>
                  </div>
                </div>
                <p class="info smaller price"><b>$0.00</b></p>
              </div>
            </ng-container>
            <ng-container *ngIf="userCart?.cartType === CART_TYPES.PLAN_ITEMS">
              <div class="item-details" *ngIf="!!dataAddons && dataAddons.length === 1">
                <div class="details-flex">
                  <div class="image-side">
                    <img src="assets/icon/data-addon-icon.svg" class="item-icon" alt="Data Addon Icon">
                  </div>
                  <div class="details">
                    <p class="info smaller" *ngIf="!!dataAddons[0]?.subtitle">
                      <b>{{dataAddons[0]?.subtitle}}</b>
                    </p>
                    <p class="info smaller" *ngIf="!!dataAddons[0]?.title">
                      {{dataAddons[0]?.title}}
                    </p>
                    <p class="info smaller last"><b>(Data Add-On)</b></p>
                    <p class="info smaller quantity" *ngIf="!!dataAddons[0]?.quantity">Quantity:
                      {{dataAddons[0]?.quantity}}
                    </p>
                    <div class="item-actions">
                      <button class="button tertiary action" (click)="goToAddons()">Change</button>
                      <button class="button tertiary action" (click)="deleteCart(dataAddons[0].id)">Delete</button>
                    </div>
                  </div>
                </div>
                <p class="info smaller price"><b>${{dataAddons[0]?.price * dataAddons[0]?.quantity}}</b></p>
              </div>
              <ng-container *ngIf="!!internationalAddon && internationalAddon.length === 1">
                <hr class="border" *ngIf="!!dataAddons && dataAddons.length === 1">
                <div class="item-details">
                  <div class="details-flex">
                    <div class="image-side">
                      <img src="assets/icon/international-calling-icon.svg" class="item-icon"
                        alt="International Calling Icon">
                    </div>
                    <div class="details">
                      <p class="info smaller" *ngIf="!!internationalAddon[0]?.subtitle">
                        <b>{{internationalAddon[0]?.subtitle}}</b>
                      </p>
                      <p class="info smaller" *ngIf="!!internationalAddon[0]?.title">
                        {{internationalAddon[0]?.title}}
                      </p>
                      <p class="info smaller last"><b>(International Add-On)</b></p>
                      <p class="info smaller quantity" *ngIf="!!internationalAddon[0]?.quantity">Quantity:
                        {{internationalAddon[0]?.quantity}}
                      </p>
                      <div class="item-actions">
                        <button class="button tertiary action" (click)="deleteCart(internationalAddon[0].id)">
                          Delete
                        </button>
                      </div>
                    </div>
                  </div>
                  <p class="info smaller price">
                    <b>${{internationalAddon[0]?.price * internationalAddon[0]?.quantity}}/mo</b>
                  </p>
                </div>
              </ng-container>
              <ng-container *ngIf="!!payGoAddons && payGoAddons.length === 1">
                <hr class="border"
                  *ngIf="(!!dataAddons && dataAddons.length === 1) || (!!internationalAddon && internationalAddon.length === 1)">
                <div class="item-details">
                  <div class="details-flex">
                    <div class="image-side">
                      <img src="assets/icon/paygo-icon.svg" class="item-icon" alt="Pay Go Icon">
                    </div>
                    <div class="details">
                      <p class="info smaller" *ngIf="!!payGoAddons[0]?.subtitle">
                        <b>{{payGoAddons[0]?.subtitle}}</b>
                      </p>
                      <p class="info smaller" *ngIf="!!payGoAddons[0]?.title">
                        {{payGoAddons[0]?.title}}</p>
                      <p class="info smaller last"><b>(Talk & text add-on)</b></p>
                      <p class="info smaller quantity" *ngIf="!!payGoAddons[0]?.quantity">Quantity:
                        {{payGoAddons[0]?.quantity}}</p>
                      <div class="item-actions">
                        <button class="button tertiary action"(click)="deleteCart(payGoAddons[0].id)">Delete</button>
                      </div>
                    </div>
                  </div>
                  <p class="info smaller price"><b>${{payGoAddons[0]?.price *
                      payGoAddons[0]?.quantity}}/mo</b>
                  </p>
                </div>
              </ng-container>
              <ng-container *ngIf="!!userCart?.simsQuantity && userCart?.simsQuantity > 0">
                <hr class="border" *ngIf="!!userCart?.addOns">
                <div class="item-details">
                  <div class="details-flex">
                    <div class="image-side">
                      <img [src]="!userCart?.eSIM ? 'assets/icon/sim-icon.svg' : 'assets/img/esim.svg'" class="sim-icon"
                        [class.esim-icon]="userCart?.eSIM" alt="SIM Icon" height="61" width="37" loading="lazy">
                    </div>
                    <div class="details">
                      <p class="info smaller"><b>{{!!userCart?.eSIM ? 'e' : ''}}SIM Card</b></p>
                      <p class="info smaller replacement"><b>(Replacement)</b></p>
                      <p class="info smaller quantity">Quantity: {{userCart?.quantity}}</p>
                      <div class="item-actions">
                        <button class="button tertiary action" (click)="deleteCart('sim')">Remove</button>
                      </div>
                    </div>
                  </div>
                  <p class="info smaller price">
                    <b>${{newSimOrder?.price}}</b>
                  </p>
                </div>
              </ng-container>
            </ng-container>
          </div>
          <div class="sub-content last" [class.hide]="!items">
            <hr class="border items-price" />
            <div class="subtotal">
              <p class="smaller">
                Item(s) price:
                <b> {{ calculateTotal() | currency}}</b>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="card-section top">
      <div class="card-header">
        <h5 class="header">Taxes and Fees</h5>
      </div>
      <div class="card-content">
        <input type="checkbox" class="hidden-checkbox" id="taxes" [(ngModel)]="taxes" />
        <label class="sub-header" for="taxes">Estimated Taxes & Fees<img src="assets/icon/tab-arrow.svg"
            class="tab-arrow" alt="Tab Arrow"></label>
        <div class="content content-padding taxes">
          <p class="title">Enter a ZIP Code to calculate your taxes & fees:</p>
          <div class="estimate-taxes">

            <div class="input-flex">
              <div class="input-holder">
                <label class="outlined-label-input">
                  <input type="text" name="zipCode" id="zipCode" autocomplete="zip-code" [(ngModel)]="zipCode"
                    #zipCodeRef="ngModel" required maxlength="5" minlength="5" [class.disabled]="!!processingRequest"
                    class="estimate-input" (input)="validateZipCode()" [pattern]="numberPattern" placeholder=" " />
                  <span>ZIP Code</span>
                </label>
              </div>

              <button class="button primary" type="button" title="Estimate" aria-label="Estimate" id="estimate-btn"
                (click)="estimateTaxesAndFees()">
                Estimate
              </button>
            </div>

            <label class="validation-message"
              *ngIf="(zipCodeTouched || zipCodeRef.touched) && zipCodeRef.hasError('required')">
              Billing ZipCode Is Required
            </label>
            <label class="validation-message" *ngIf="!validZipCode && !!zipCodeRef.value">
              Invalid ZIP Code. Try another one!
            </label>
          </div>
          <div class="taxes-result-part" *ngIf="!!estimatedTaxes || !!estimatedFees">
            <div class="flex first">
              <p class="key">
                Govt. taxes & fees
                <span class="tooltip taxes">
                  <img src="assets/icon/circle-qst-mark.svg" class="info smaller-icon" alt="Question Mark Icon">
                  <span class="tooltipInfo tooltipInfo-short">
                    <p class="smallest">
                      This includes any federal, state county, city or district
                      taxes that are applicable to the retails sale of prepaid wireless communication
                      services in your ZIP Code.
                    </p>
                  </span>
                </span>
              </p>
              <p class="value smaller">{{ !!estimatedTaxes ? (estimatedTaxes | currency) : '-' }}</p>
            </div>
            <div class="flex">
              <p class="key">Surcharges & fees</p>
              <p class="value smaller">{{ !!estimatedFees ? (estimatedFees | currency) : '-' }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
<app-checkout-nav (cancel)="cancel()" (next)="goToCheckout()" nextBtnText="Checkout"></app-checkout-nav>
